// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2crTE","info":"UpdateTermsInfo_info__1xJor"};